import React from 'react';
import useStyle from './warningHeaderBlock.style';
import { FlatIcon } from 'components/atoms/Icons/FlatIcon';

interface WarningHeaderBlockProps {
  variant: 'EspaceProf' | 'MesCommandes' | 'CommandeSingle';
  numberOfOrders?: number;
}

export const WarningHeaderBlock = ({
  variant,
  numberOfOrders
}: WarningHeaderBlockProps) => {
  const classes = useStyle();

  return (
    <div className={classes.root}>
      <div>
        <FlatIcon icon={'Warning'} color="#FFFFFF" />
        {variant === 'CommandeSingle' ? (
          <p>Commande à relancer</p>
        ) : (
          <p>
            {numberOfOrders && numberOfOrders} {numberOfOrders ? 'c' : 'C'}
            ommandes à relancer
          </p>
        )}
      </div>
      {variant !== 'CommandeSingle' && (
        <p>
          {variant === 'EspaceProf'
            ? 'Les élèves avec des commandes à relancer sont de couleur orange.'
            : 'Les commandes à relancer ont une bordure orange.'}
        </p>
      )}
    </div>
  );
};
